<nav>
    <mat-toolbar #navToolBar class="nav-header mat-elevation-z2">
        <div class="toggle-button">
            <button mat-icon-button (click)="onToggleSideNav()" [matTooltip]="'Toggle Menu'">
                <mat-icon>menu</mat-icon>
            </button>
        </div>
        @if(this.isRouteHome()) {
            @if(!mobileQuery.matches) {
                <a (click)="goToHome()">
                    <img class="navbar-image" src="../../../../assets/images/Safely-Logo_Standard.png" alt="Safely logo" title="Safely">
                </a>
            }
        } @else() {
            <div class="nav-header-container ps-1 pe-1" style="width:100%">
                @if(!mobileQuery.matches) {
                    <div class="col-1 d-flex nav-img justify-content-center">
                        <a (click)="goToHome()">
                            <img class="navbar-image" src="../../../../assets/images/Safely-Logo_Standard.png" alt="Safely logo" title="Safely">
                        </a>
                    </div>
                }
                <div class="col-3 d-flex justify-content-start">
                    @if(isComponentRouteSearchable() && !isComponentOrganizationSortable()) {
                        <app-organization-search></app-organization-search>
                    }
                </div>
                <div class="col-3 d-flex justify-content-end align-items-center">
                    <div *ngIf="loggedIn" class="d-flex user-login-block" [matMenuTriggerFor]="profileMenu"
                    [matTooltipShowDelay]="1000" matTooltip="{{ this.loggedInUser?.first_name }} {{ this.loggedInUser?.last_name }}">
                        <span class="user-icon-text"> 
                            <mat-icon>person</mat-icon>
                        </span>
                        <div class="user-icon-text" *ngIf="!mobileQuery.matches">
                            {{ this.loggedInUser?.first_name }} {{ this.loggedInUser?.last_name }}
                        </div>
                    </div>
                </div>
                <mat-menu #profileMenu="matMenu" xPosition="before">
                    <div>                  
                        <button mat-menu-item (click)="logout()">
                            <mat-icon>input</mat-icon>
                            <span>Logout</span>
                        </button>
                    </div>
                </mat-menu>
            </div>
        }
    </mat-toolbar>
</nav>